function findCodeBlockDescriptor(descriptors, language, meta, defaultLanguage) {
  const sortedDescriptors = [...descriptors].sort((a, b) => b.priority - a.priority);
  const resolvedMeta = meta ?? "";
  return sortedDescriptors.find((descriptor) => descriptor.match(language ?? "", resolvedMeta)) ?? sortedDescriptors.find((descriptor) => descriptor.match(defaultLanguage ?? "", resolvedMeta));
}
export {
  findCodeBlockDescriptor
};
